import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { get_User_Filter } from "../../../store/actions/CommanAction";
import { Online_Puja_Filters } from "../../../store/actions/CommanAction";
import DataTable from "react-data-table-component";
import { Dropdown, Modal, Nav, Tab } from "react-bootstrap";
import Loader from "../Loader/Loader";
import { Spinner } from "react-bootstrap";
import Select from "react-select";
import { get_AstroData } from "../../../store/actions/CommanAction";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import swal from "sweetalert";
import { customStyles } from "../Utility/Utility";

const OnlinePujaFilter = () => {
  const [filteredData, setFilteredData] = useState([]);
  const [selectedAstro, setSelectedAstro] = useState("");
  const [Id, setId] = useState("");

  const dispatch = useDispatch();
  const ChatFilter = useSelector(
    (state) => state.feedBackReducer.ONlinePujaFilter
  );
 

  const AstroData = useSelector((state) => state.feedBackReducer.AstroData);

  useEffect(() => {
    if (AstroData && Array.isArray(AstroData)) {
      const filtered = AstroData.map(({ DisplayName, ID }) => ({
        label: DisplayName,
        value: ID,
      }));
      setFilteredData(filtered);
    }
  }, [AstroData]);

  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [orderStatus, setOrderStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [astroname, setAstroname] = useState("");
  const [comment, setcomment] = useState("");

  useEffect(() => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    const formattedToday = `${yyyy}-${mm}-${dd}`;

    const defaultStartTime = `${formattedToday}`;
    const defaultEndTime = `${formattedToday}`;

    setStartTime(defaultStartTime);
    setEndTime(defaultEndTime);

    setLoading(true);

    fetchData(formattedToday, formattedToday, orderStatus, isActive);
  }, [dispatch]);

  useEffect(() => {
    dispatch(get_AstroData(isActive));
  }, []);

  const fetchData = async (fromDate, toDate, orderStatus, isActive) => {
    setLoading(true);
    await dispatch(
      Online_Puja_Filters(fromDate, toDate, orderStatus, isActive)
    );
    setLoading(false);
  };

  const handleSearch = (isActive) => {
    const formatDate = (dateTime) => {
      if (!dateTime) return null;
      const date = new Date(dateTime);
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    };

    const formattedStartDate = formatDate(startTime);
    const formattedEndDate = formatDate(endTime);

    const data = {
      FromDate: formattedStartDate,
      Todate: formattedEndDate,
      orderStatus: orderStatus,
    };

    fetchData(data.FromDate, data.Todate, orderStatus, isActive);
  };

  const handleReset = () => {
    const today = new Date().toISOString().split("T")[0];

    setStartTime("");
    setEndTime("");

  };

  const handleEditClick = (row) => {
    setEditModal(true);
    setId(row.BookingPujaID);
  };

  const UpdateSlider = async (e) => {
    e.preventDefault();

    let error = false;
    let errormsg = "";

    if (
      !selectedAstro ||
      !selectedAstro.label ||
      selectedAstro.label.trim() === ""
    ) {
      errormsg = "Please select an astrologer";
      error = true;
    }

    if (!error) {
      const insertdata = {
        AstroID: selectedAstro.value,
        PujaStatus: "pending",
        BookingPujaID: Id,
        Description: comment,
      };

      await AddUpdate("BookingPuja/UpDate_AssignAstro", insertdata);
      await dispatch(
        Online_Puja_Filters(startTime, endTime, orderStatus, isActive)
      );
      setEditModal(false);
      setAstroname("");
      setcomment("");
      setId("");
      setSelectedAstro(null);
    } else {
      swal("Oops", errormsg, "error");
    }
  };

  const columns = [
    {
      name: "Puja Name",
      selector: (row) => row.PujaName,
      sortable: true,
    },
    {
      name: "User Name",
      selector: (row) => row.NickName,
      sortable: true,
    },

    {
      name: "Amount",
      selector: (row) => row.Amt,
      sortable: true,
    },

    {
      name: "Pooja Status",
      // selector: (row) => row.PujaStatus,
      selector: (row) => (row.PujaStatus ? row.PujaStatus : "Not Assigned"),

      sortable: true,
    },
    {
      name: "Assigned Astorologer",
      selector: (row) => row.AstrologersName,
      sortable: true,
    },

    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 50 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <div style={{ position: "absolute", top: 4, right: 50 }}>
          <Dropdown>
            <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
              <Dropdown.Item onClick={() => handleEditClick(row)}>
                Assign Puja
              </Dropdown.Item>
             
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="form-group main_card">
        <h2 style={{ color: '#f7931e', fontWeight: 700 }}> Pooja Booking List</h2>
        <div className="row mt-3">
          <div className="col-3">
            <div className="form-group ">
              <label>Start Time</label>
              <input
                type="date"
                // className="form-control"
                value={startTime}
                onChange={(e) => setStartTime(e.target.value)}
              />
            </div>
          </div>
          <div className="col-3">
            <div className="form-group">
              <label>End Time</label>
              <input
                type="date"
                // className="form-control"
                value={endTime}
                onChange={(e) => setEndTime(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center mt-3">
          <label
            style={{
              marginRight: "10px",
              marginTop: "10px",
              color: "black",
              fontSize: "15px",
              fontStyle: "bold",
            }}
          >
            Order Status:
          </label>
          <div className="d-flex">
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px", // spacing between radio and text
                marginRight: "10px",
                color: "black",
                marginTop: "18px",
              }}
            >
              <input
                type="radio"
                name="orderStatus"
                value="complete"
                checked={orderStatus === "complete"}
                onChange={() => setOrderStatus("complete")}
              />
              Complete
            </label>

            <label style={{
              display: "flex",
              alignItems: "center",
              gap: "8px", // spacing between radio and text
              marginRight: "10px",
              color: "black",
              marginTop: "18px",
            }}>
              <input
                type="radio"
                name="orderStatus"
                value="pending"
                checked={orderStatus === "pending"}
                onChange={() => setOrderStatus("pending")}
              />
              Pending
            </label>
            <label style={{
              display: "flex",
              alignItems: "center",
              gap: "8px", // spacing between radio and text
              marginRight: "10px",
              color: "black",
              marginTop: "18px",
            }}>
              <input
                type="radio"
                name="orderStatus"
                value="all"
                checked={orderStatus === null}
                onChange={() => setOrderStatus(null)}
              />
              All
            </label>


            <button
              className="btn btn-primary mt-3"
              onClick={() => handleSearch(isActive)}
            >
              Search
            </button>
            <button className="btn btn-secondary  ms-2 mt-3" onClick={handleReset}>
              Reset
            </button>


          </div>
        </div>




      </div>

      <Modal
        className="modal fade "
        show={editModal}
        onHide={setEditModal}
        backdrop="static"
      >
        <div className="" role="document">
          <div className="">
            <form>
              <div className="modal-header">
                <h4 className="modal-title fs-20">Assign Booking Pooja</h4>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setEditModal(false)}
                  data-dismiss="modal"
                ></button>
              </div>
              <div className="modal-body p-3">
                <i
                  className="flaticon-cancel-12 close"
                  data-dismiss="modal"
                ></i>
                <div className="add-contact-box">
                  <div>
                    <label htmlFor="">Select Astrologer</label>
                    <span className="text-danger star-error">*</span>
                    <Select
                      options={filteredData}
                      value={selectedAstro}
                      onChange={(selectedOption) =>
                        setSelectedAstro(selectedOption)
                      }
                      placeholder="Select Astrologer"
                      isSearchable
                    />
                  </div>
                </div>
                <div className="add-contact-box">
                  <div className="add-contact-content">
                    <label htmlFor="">Comment</label>
                    <span className="text-danger star-error">*</span>
                    <input
                      type="text"
                      className="form-control"
                      autoComplete="off"
                      name="comment"
                      required="required"
                      value={comment}
                      onChange={(e) => {
                        setcomment(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={UpdateSlider}
                >
                  Assign
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setEditModal(false);
                  }}
                  className="btn btn-danger"
                >
                  {" "}
                  <i className="flaticon-delete-1"></i> Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>

      <div className="col-12 mt-2 main_card">
        <div className="card-action coin-tabs mb-2">
          <Nav variant="tabs">
            <Nav.Item as="li" className="nav-item">
              <Nav.Link
                className={`nav-link ${isActive ? "active" : ""}`}
                onClick={() => {
                  setIsActive(true);
                  handleSearch(true);
                }}
              >
                Active
              </Nav.Link>
            </Nav.Item>
            <Nav.Item as="li" className="nav-item">
              <Nav.Link
                className={`nav-link ${!isActive ? "active" : ""}`}
                onClick={() => {
                  setIsActive(false);
                  handleSearch(false);
                }}
              >
                Inactive
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </div>
        {loading ? (
          <Loader />
        ) : (
          <DataTable
            dense
            data={ChatFilter || []}
            columns={columns}
            selectableRowsHighlight
            customStyles={customStyles}
            pagination
            persistTableHead={true}
            noDataComponent={"There are no data to display"}
          />
        )}
      </div>
    </div>
  );
};
export default OnlinePujaFilter;
